!customElements.get("po-cart-rxc-item") && customElements.define("po-cart-rxc-item", class PoCartRxcItem extends HTMLElement {
    connectedCallback () {
        this.cartForm = this.closest("form");
        this.currPrescription = null;
        this.details = this.querySelector("details");
        this.expanded = false;
        this.iframeContainer = this.querySelector("[data-iframe-container]");
        this.iframeId = this.dataset.rxcFrameId || "rxc-iframe";
        this.isError = false;
        this.isLoading = false;
        this.relationshipId = this.dataset.relationshipId;
        this.itemUrl = this.dataset.itemUrl;
        this.lensInfo = this.querySelector("[data-lens-info]");
        this.itemId = this.dataset.itemId;
        this.lineKey = this.dataset.lineKey;
        this.market = this.dataset.market;
        this.marketId = this.dataset.marketId;
        this.rxcActions = this.querySelectorAll("[data-rxc-action]");
        this.shopRoot = window.Shopify?.routes?.root || "/";
        this.shopUrl = window.location.host + window.Shopify?.routes?.root;
        this.frameVariantId = this.dataset.frameVariantId;
        this.flow = this.dataset.flow;
        this.monogramText = this.dataset.monogramText;
        this.monogramAttributeKey = this.dataset.monogramAttributeKey;

        this.prescriptionFlowElements = {
            tableContainer: this.querySelector("[data-prescription-table-container]"),
            fileAlert: this.querySelector("[data-prescription-file-alert]"),
            afterCheckoutAlert: this.querySelector("[data-prescription-checkout-alert]"),
        }

        this.details?.addEventListener("toggle", this.detailsToggleHandler);
        this.rxcActions.forEach(btn => btn.addEventListener("click", this.rxcAction_clickHandler));
        window.addEventListener("message", this.window_messageHandler);

        if (this.flow === "3") {
            this.prescriptionFlowElements.afterCheckoutAlert?.toggleAttribute("data-visible", true);
        }

        this.updateLineItemImage();
        this.checkPrescriptionLenses();
    }

    disconnectedCallback () {
        this.details?.removeEventListener("toggle", this.detailsToggleHandler);
        window.removeEventListener("message", this.window_messageHandler);
    }

    displayPrescriptionLenseCTA(display) {
        this.rxcActions.forEach(btn => btn.style.display = display);
    }

    checkPrescriptionLenses() { 
        const market = this.getAttribute('data-market');
    
        // Estrai e normalizza l'handle
        const urlSlices = URL.parse(this.itemUrl, window.location.origin).pathname.split('/');
        const productHandle = urlSlices[urlSlices?.length - 1];
        const [modelCode, colorCode] = productHandle.split('-');
        const adaptedModelCode = modelCode.toUpperCase();
        const adaptedMoCo = modelCode.toUpperCase() + '__' + colorCode?.toUpperCase();        

        // Local variables
        const BASE_URL = 'https://assets.persol.com/extra/image/rxcbe';
        const ENVIRONMENT = this.dataset.env;
        const BRAND_CODE = 'PO';

        this.fetchAvailability(
            BASE_URL,
            ENVIRONMENT,
            BRAND_CODE,
            market,
            adaptedModelCode,
            adaptedMoCo
        );
    }

    fetchAvailability(BASE_URL, ENVIRONMENT, BRAND_CODE, market, adaptedModelCode, adaptedMoCo) {

      fetch(`${BASE_URL}/${ENVIRONMENT}/availability/${BRAND_CODE}/${market}/availability_${adaptedModelCode}.json`)
        .then(res => res.json())
        .then(res => {
          const isMocoAvailable = res[adaptedMoCo]?.availability === true ? true : false;
          const isModelAvailable = Object.keys(res).some(key => key.startsWith(adaptedModelCode + '__'));

          if (isMocoAvailable && isModelAvailable) {
            this.displayPrescriptionLenseCTA("block");
            return;
          }
          this.displayPrescriptionLenseCTA("none");
        })
        .catch(() => {
            this.displayPrescriptionLenseCTA("none");
        });
    }

    appendIframe () {
        const proxyPath = this.market === 'US' ? 'rxc-us' : 'rxc';
        const iframeUrl = new URL(`${window.location.protocol}//${this.shopUrl}apps/${proxyPath}/prescription/rx-item`);
        const iframe = document.getElementById(this.iframeId) || document.createElement("iframe");

        iframeUrl.searchParams.set("prescriptionId", this.currPrescription?.prescriptionId);
        iframeUrl.searchParams.set("market", this.market);
        iframeUrl.searchParams.set("market_id", this.marketId);

        iframe.id = this.iframeId;
        iframe.title = "RX - Item";
        iframe.tabIndex = -1;
        iframe.src = iframeUrl.toString();

        iframe.onerror = () => {
            console.error("RXC App Embed Error");
        }

        if (!this.iframeContainer) {
            this.iframeContainer = document.createElement("div");
            this.append(this.iframeContainer);
            console.warn("Frame container not found. Created new element");
        }

        this.iframeContainer.append(iframe);
    }

    closeDetails () {
        if (this.details?.open) {
            this.details.open = false;
        }

        this.expanded = false;
    }

    detailsToggleHandler = (event) => {
        this.expanded = event.newState === "open";

        if (this.isError) {
            this.resetDisplay();
            this.isError = false;
        }

        if (this.isLoading && !this.iframeContainer?.querySelector("iframe")) {
            this.isLoading = false;
        }
        
        if (this.expanded && !this.isLoading) {
            this.isLoading = true;

            if(window.location.href.includes('order')){
                this.getPrescriptionFromOrder().then(data => {
                    if (!data) {
                        console.error("Unable to get prescription id");
                        this.isLoading = false;
                        this.displayError();
                        return;
                    }
                    this.displayData(data);
                    this.isLoading = false;
                });
                return;
            }

            if (this.currPrescription) {
                this.appendIframe();
                return;
            }
            
            this.rxcActions.forEach(btn => btn.disabled = true);
            
            this.getPrescription().then(data => {
                if (!data) {
                    console.error("Unable to get prescription id");
                    this.isLoading = false;
                    this.displayError();
                    return;
                }

                this.currPrescription = data;

                if (data.prescriptionFlow) {
                    this.flow = data.prescriptionFlow;
                }

                this.rxcActions.forEach(btn => btn.disabled = false);
                this.appendIframe();
            });
        }
    }

    displayData (data) {
        const lensOptions = data.lens_data.lensOptions;
        

        if (!lensOptions) {
            console.error("No lens options found in data");
            return;
        }

        const lensLiTemplate = this.querySelector("[data-lens-li-template]");

        if (!this.lensInfo || !lensLiTemplate) {
            console.error("Lens list or template not found");
            return;
        }

        this.resetDisplay();

        Object.values(lensOptions).sort((a, b) => a.sequence - b.sequence).forEach(opt => {
            const content = lensLiTemplate.content.cloneNode(true);
            const nameDisplay = content.querySelector("[data-lens-name]");
            const descriptionDisplay = content.querySelector("[data-lens-description]");
            const children = opt.children;
            let description = opt.description || "";

            if (Array.isArray(children) && children.length > 0) {
                description = children.sort((a, b) => a.sequence - b.sequence).map(c => c.name).join(" ");
            }

            if (nameDisplay) {
                nameDisplay.textContent = opt.name;
            }

            if (descriptionDisplay) {
                descriptionDisplay.textContent = description;
            }

            
            this.lensInfo.appendChild(content);
        });

        switch (this.flow) {
            case "1":
                this.showPrescriptiontable(data.health_data);
                this.showPrescriptionPdTable(data.health_data);
                break;
            case "2":
                this.showFileName(data.filename);
                break;
            case "3":
                this.prescriptionFlowElements.afterCheckoutAlert?.toggleAttribute("data-visible", true);
                break;
            default:
                console.log("Prescription:", this.currPrescription);
                console.log("Data:", data);
        }
    }

    displayError () {
        const errorTemplate = this.querySelector("[data-error-template]");

        if (!this.lensInfo || !errorTemplate) {
            console.error("Lens list or template not found");
            return;
        }
        
        this.resetDisplay();

        const content = errorTemplate.content.cloneNode(true);

        this.lensInfo.appendChild(content);
        this.isError = true;
    }

    showPrescriptiontable (data) {
        const container = this.prescriptionFlowElements.tableContainer;

        if (!container) {
            console.error("Prescription table container not found");
            return;
        }

        container.querySelectorAll("[data-prescription-table]").forEach(table => {
            const noneMsg = table.dataset.noneMsg ?? "";

            const cellsMap = {
                SPH_OD: table.querySelector("[data-od-sph]"),
                SPH_OS: table.querySelector("[data-os-sph]"),
                CYL_OD: table.querySelector("[data-od-cyl]"),
                CYL_OS: table.querySelector("[data-os-cyl]"),
                AX_OD: table.querySelector("[data-od-axis]"),
                AX_OS: table.querySelector("[data-os-axis]"),
                ADD_OD: table.querySelector("[data-od-add]"),
                ADD_OS: table.querySelector("[data-os-add]")
            }

            for (let key in cellsMap) {
                const cell = cellsMap[key];

                if (cell) {
                    cell.textContent = data[key] ?? noneMsg;
                }
            }
        });

        container.toggleAttribute("data-visible", true);
    }

    showPrescriptionPdTable (data) {
        const pdTable = this.prescriptionFlowElements.tableContainer?.querySelector("[data-prescription-pd-table]");

        if (!pdTable) {
            console.error("Prescription PD table not found");
            return;
        }

        const pdTableHead = pdTable.querySelector("thead");
        
        const cellsMap = {
            PD_OS: pdTable.querySelector("[data-os-pd]"),
            PD_OD: pdTable.querySelector("[data-od-pd]"),
        }

        let itemCount = 0;

        for (let key in cellsMap) {
            const cell = cellsMap[key];
            const item = data[key];

            if (!cell) {
                console.warn(`Cell for ${key} not found in PD table`);
                continue;
            }

            if (!item) {
                cell.style.display = "none";
                continue;
            }

            cell.textContent = item;
            cell.style.removeProperty("display");
            itemCount++;
        }

        if (pdTableHead) {
            itemCount < 2 ? pdTableHead.style.display = "none" : pdTableHead.style.removeProperty("display");
        }

        this.prescriptionFlowElements.tableContainer?.toggleAttribute("data-visible", true);
    }

    showFileName (fileName) {
        const fileDisplay = this.prescriptionFlowElements.fileAlert?.querySelector("[data-file-display]");
        
        if (fileDisplay) {
            fileDisplay.textContent = fileName;
        }

        this.prescriptionFlowElements.fileAlert?.toggleAttribute("data-visible", true);
    }

    async getPrescriptionFromOrder() {
        const wrapper = document.querySelector("[data-order-id]");
        const orderId = wrapper?.dataset.orderId;

        if (!orderId) {
            console.warn("Nessun data-order-id trovato");
            return null;
        }

        try {
            const proxyPath = this.market === 'US' ? 'rxc-us' : 'rxc';
            const url = `${this.shopUrl}/apps/${proxyPath}/prescription/retrievebyorder?orderId=` + orderId;
            const resp = await fetch(url, { credentials: 'same-origin' });
            if (!resp.ok) throw new Error(`Order fetch failed: ${resp.status}`);
            return resp.json()
        } catch (e) {
            console.error("Error fetching from order endpoint:", e);
        }
        
        return null;
    }

    async getPrescription () {
        try {
            const response = await fetch(`${this.shopRoot}cart.js`, { method: "GET" });

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const cart = await response.json();
            const attributes = cart.attributes || {};

            for (let key in attributes) {
                if (!key.startsWith("prescription_")) {
                    continue;
                }

                const value = JSON.parse(attributes[key] || "{}");

                if (value && value["_itemsRelationshipId"] === this.relationshipId) {
                    return value;
                }
            }
        }
        catch (error) {
            console.error(error);
        }
        
        return null;
    }

    resetDisplay () {
        if (this.lensInfo) {
            this.lensInfo.innerHTML = "";
        }
        
        for (let key in this.prescriptionFlowElements) {
            this.prescriptionFlowElements[key]?.toggleAttribute("data-visible", false);
        }
    }

    rxcAction_clickHandler = async (event) => {
        const action = event.currentTarget.dataset.rxcAction;
        const url = URL.parse(this.itemUrl, window.location.origin);

        if (!url) {
            return;
        }

        switch (action) {
            case "add":
                url.searchParams.set("isAddLenses", "true");
                break;
            case "edit":
                url.searchParams.set("isEditLenses", "true");
                break;
            default:
                console.error("Unknown RXC action:", action);
        }

        if (this.currPrescription) {
            url.searchParams.set("lensUniqueId", this.currPrescription.lensUniqueId);
        }

        url.searchParams.set("orderItemId", this.lineKey);
        url.searchParams.set("frameUniqueId", this.frameVariantId);
        url.searchParams.set("variant", this.frameVariantId);

        await this.flagMonogramRemoval();

        window.location.href = url.toString();
    }

    // Prescription lenses and monogram cannot coexist: the RXC app replaces the frame line and
    // Shopify deletes the nested monogram line with it, leaving no trace to render the notice
    // from. Persist it as a cart attribute now, while the theme still owns the cart.
    async flagMonogramRemoval () {
        if (!this.monogramText || !this.monogramAttributeKey) {
            return;
        }

        try {
            await fetch(`${this.shopRoot}cart/update.js`, {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({
                    attributes: {
                        [this.monogramAttributeKey]: JSON.stringify({
                            text: this.monogramText,
                            frameVariantId: this.frameVariantId,
                        }),
                    },
                }),
            });
        } catch (error) {
            // Never block the RXC flow: without the flag the user only misses the notice.
            console.error("Could not flag monogram removal:", error);
        }
    }

    updateLineItemImage () {
        if (!this.relationshipId) {
            return;
        }
        
        this.getPrescription().then(data => {
            if (!data) return;
            this.currPrescription = data;

            if (data.prescriptionFlow) {
                this.flow = data.prescriptionFlow;
            }
            
            if (data.itemImage && data.itemImage.trim() !== "") {
                this.cartForm?.querySelectorAll(`[data-line-item-image="${this.lineKey}"] img`).forEach(img => {
                    img.closest("picture")?.querySelectorAll("source").forEach(s => s.remove());
                    img.src = data.itemImage;
                    img.srcset = "";
                });
            }

            if (this.flow === "3") {
                this.prescriptionFlowElements.afterCheckoutAlert?.toggleAttribute("data-visible", true);
            }
        });
    }

    window_messageHandler = (event) => {
        const rxcAppData = event?.data?.rxcApp;
        if (!rxcAppData) return;

        switch (rxcAppData.type) {
            case "RX_ITEM_DATA_READY":
                if (rxcAppData.id === this.currPrescription?.prescriptionId) {
                    this.displayData(rxcAppData.payload);
                    this.isLoading = false;
                }
                break;
            case "RX_ITEM_ERROR":
                if (this.expanded) {
                    this.isLoading = false;
                    this.displayError();
                    console.log(rxcAppData);
                }
                break;
            default:
                console.warn("Unknown RXC App message type:", rxcAppData.type);
        }
    }
});